import __request__ from "routing/request";
export function metadataForObject(arg0, requestOptions) {
  return __request__("POST", "/views/search/metadata", arg0, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function metadata(searchId, requestOptions) {
  return __request__("GET", `/views/search/metadata/${searchId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
